import { ArrowRight, Eye, RefreshCw, Circle } from "lucide-react";

function Metric({ label, value, accent }) {
  return (
    <div className="rounded-lg border border-zinc-800/80 bg-zinc-950/40 px-3 py-2.5">
      <div className="font-mono text-base font-bold text-white">{value}</div>
      <div className="mt-0.5 text-[10px] font-medium uppercase tracking-wider text-zinc-500">{label}</div>
    </div>
  );
}

export function RichPortalCard({ p, i = 0, t, onDetail, onOpen }) {
  const live = p.status === "live";
  const accent = p.accent || "#3b82f6";

  return (
    <div
      data-testid={`control-portal-${p.portal_key}`}
      className="kw-fade-up group relative flex flex-col overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900 p-5 transition-all duration-300 hover:border-zinc-600"
      style={{ animationDelay: `${i * 50}ms` }}
    >
      <div
        className="pointer-events-none absolute -right-20 -top-20 h-40 w-40 rounded-full opacity-20 blur-3xl transition-opacity duration-500 group-hover:opacity-40"
        style={{ background: accent }}
      />
      <div className="relative flex items-start justify-between">
        <div className="flex items-center gap-2.5">
          <span className="h-8 w-1.5 rounded-full" style={{ background: accent }} />
          <span className="font-heading text-xl font-bold text-white" data-testid={`control-portal-name-${p.portal_key}`}>{p.name}</span>
        </div>
        <span
          className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider"
          style={
            live
              ? { background: "rgba(16,185,129,0.1)", color: "#34d399", borderColor: "rgba(16,185,129,0.25)" }
              : { background: "rgba(255,255,255,0.03)", color: "#a1a1aa", borderColor: "#3f3f46" }
          }
        >
          <Circle className="h-2 w-2 fill-current" />
          {live ? t("control.live") : t("control.skeleton")}
        </span>
      </div>

      <div className="relative mt-5 grid grid-cols-2 gap-2.5">
        <Metric label={t("control.tabProviders")} value={p.providers} />
        <Metric label={t("card.approved")} value={p.approved} />
        <Metric label={t("card.members")} value={p.members} />
        <Metric label={t("stat.open_inquiries") || t("control.openInvoices")} value={p.open} />
      </div>

      <div className="relative mt-3 flex items-center gap-4 text-[11px] text-zinc-500">
        <span className="inline-flex items-center gap-1.5" title={t("card.synced")}>
          <RefreshCw className="h-3 w-3" style={{ color: p.synced > 0 ? "#34d399" : "#71717a" }} />
          {p.synced}/{p.approved} {t("card.synced")}
        </span>
        {p.new_7d > 0 && (
          <span className="inline-flex items-center gap-1" style={{ color: "#34d399" }}>+{p.new_7d} {t("kpi.new7d")}</span>
        )}
      </div>

      <div className="relative mt-5 flex items-center justify-between border-t border-zinc-800 pt-4">
        <button
          onClick={onDetail}
          data-testid={`control-detail-${p.portal_key}`}
          className="inline-flex items-center gap-2 rounded-md bg-zinc-800 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-zinc-700"
        >
          <Eye className="h-3.5 w-3.5" /> {t("control.details")}
        </button>
        <button
          onClick={onOpen}
          data-testid={`control-open-${p.portal_key}`}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-400 transition-colors hover:text-white"
        >
          {t("control.openPortal")} <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
